<!--
 * @Author: your name
 * @Date: 2021-12-07 15:40:36
 * @LastEditTime: 2022-01-26 13:57:25
 * @LastEditors: Please set LastEditors
 * @Description: 新闻动态
 * @FilePath: \new-website-1123\src\views\news\home\index.vue
-->
<template>
  <div class="news-home">
    <ul class="news-home-ul">
      <li class="outer_clear" v-for="(item, index) in newList" :key="index">
        <div class="news-home-ul-text animation-3">
          <w-title
            :model="item.model"
            :modelkey="item.modelkey"
            direction="left"
          ></w-title>
          <div
            class="news-home-ul-article animation-3"
            v-for="(data, index2) in item.list"
            :key="index2"
            @click.stop="goMore(data.url)"
          >
            <div class="news-home-ul-article-img">
              <img :src="data.img" />
            </div>

            <h2>{{ data.title }}</h2>
            <h4>{{ data.data }}</h4>
            <div class="news-home-more animation-3">
              查看详情
              <img
                class="ml10"
                width="40"
                src="@/assets/images/common/jr.png"
                alt="上太科技"
              />
            </div>
          </div>
        </div>
        <div class="news-home-ul-img">
          <img :src="item.img" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import wTitle from "@/components/sTitle/viewtitle";
export default {
  name: "news-home",
  components: {
    wTitle,
  },
  data() {
    return {
      newList: [
        {
          model: "上太",
          modelkey: "动态",
          img: require("../../../assets/images/news/newsimg1.jpg"),
          list: [
            {
              title: "财政部、国家粮食和物资储备局发文，深入推进优质粮食工程",
              data: "2021-11-08",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg1.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg2.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg3.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg4.jpg"),
            },
          ],
        },
        {
          model: "行业",
          modelkey: "动态",
          img: require("../../../assets/images/news/newsimg2.jpg"),
          list: [
            {
              title: "财政部、国家粮食和物资储备局发文，深入推进优质粮食工程",
              data: "2021-11-08",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg5.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg6.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg7.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg8.jpg"),
            },
          ],
        },
        {
          model: "影像",
          modelkey: "风采",
          img: require("../../../assets/images/news/newsimg3.jpg"),
          list: [
            {
              title: "财政部、国家粮食和物资储备局发文，深入推进优质粮食工程",
              data: "2021-11-08",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg1.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg2.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg3.jpg"),
            },
            {
              title:
                "农业农村部乡村产业发展司负责人：​拓展农业多种功能 提升乡村...",
              data: "2021-10-28",
              url: "/news/details",
              img: require("../../../assets/images/news/newsimg4.jpg"),
            },
          ],
        },
      ],
    };
  },
  created() {},
  computed: {},
  methods: {
    goMore(data) {
      this.$router.push(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.news-home-ul {
  color: $color-text;
  & li:nth-child(2n) {
    .news-home-ul-text {
      float: right;
      padding-left: 90px;
    }
  }
  li {
    height: calc(100vh - 80px);
    .news-home-ul-text {
      width: 50%;
      height: 100%;
      float: left;
      padding-left: 210px;
      padding-top: 40px;
      .news-home-ul-article {
        color: rgba(255, 255, 255, 0.4);
        margin-bottom: 24px;
        cursor: pointer;
        padding-right: 100px;

        .news-home-ul-article-img {
          width: 100%;
          height: 4.55rem;
          display: none;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        &:hover {
          color: $color-text;
        }
        h2 {
          font-size: 28px;
          margin-bottom: 16px;
          font-weight: normal;
          line-height: 40px;
          height: 80px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: break-word;
          white-space: normal;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        h4 {
          font-size: 20px;
          margin-bottom: 26px;
          font-weight: normal;
        }
        .news-home-more {
          height: 0;
          display: block;

          overflow: hidden;
          color: $color-active;
        }
        &:hover .news-home-more {
          height: 20px;
        }
      }
    }
    .news-home-ul-img {
      width: 50%;
      height: 100%;
      float: right;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

@media only screen and (max-width: 800px) {
  .news-home-ul {
    & li:nth-child(2n) {
      .news-home-ul-text {
        float: none;
      }
    }
    li {
      height: auto;
      .news-home-ul-text {
        width: 86.4%;
        margin: 0 auto;
        float: none;
        padding-left: 0;
        padding-top: 0.36rem;
        .news-home-ul-article {
          padding-right: 0;
          margin-bottom: 0.27rem;
          background: rgba(255, 255, 255, 0.05);
          .news-home-ul-article-img {
            display: block;
            margin-bottom: 0.33rem;
          }
          h2 {
            font-size: 0.29rem;
            color: #fff;
            line-height: 0.4rem;
            height: 0.8rem;
            margin-bottom: 0.25rem;
            padding: 0 0.27rem;
          }
          h4 {
            font-size: 0.22rem;
            padding: 0 0.27rem;
            margin-bottom: 0.35rem;
          }
        }
      }
      .news-home-ul-img {
        display: none;
      }
    }
  }
}
</style>
